jQuery(function($){
	$(document).on("click", ".loadmore-search-btn-wrapper a", function (e) {
		e.preventDefault();
		var $this = $(this);
		var target = $this.attr('href');
		var holderSelector = '.search-results-list';
		var btnWrap = $this.closest('.loadmore-search-btn-wrapper');
		$this.text("Loading...");

		$.get(target, function(response){
			var results = $(response).find(holderSelector).children();
			btnWrap.remove();
			$(holderSelector).append(results);
		});
	});

	$('.search-results-filter-buttons a').on('click', function(e){
		e.preventDefault();
		var $this = $(this);
		var target = $this.attr('href');
		var holderSelector = '.search-results-list';
		var holder = $(holderSelector);

		$('.search-results-filter-buttons a').removeClass('active');
		$this.addClass('active');

		holder.append(
			'<div class="loading"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>'
		);

		$.get(target, function(response){
			var results = $(response).find(holderSelector).children();
			holder.html(results);
			window.history.replaceState({}, "", target);
		});

	});
});
